'use memo';

import { useState } from 'react';
import { ShortcutListDialog, useShortcut } from '@/features/shortcuts';
import { useToggleLanguage } from '@/lib/i18n/hooks/useToggleLanguage';

/**
 * アプリ全体に常駐するショートカット配線（__root から render）。
 * registry の global ショートカットの listener と一覧 dialog をここに集約する。
 * - shortcuts.help（⌘/）: ショートカット一覧を開く
 * - lang.switch（⌃⌘L / 開発者用）: 日英トグル
 */
export function GlobalShortcuts() {
  const [helpOpen, setHelpOpen] = useState(false);
  const toggleLanguage = useToggleLanguage();
  useShortcut('shortcuts.help', () => setHelpOpen(true));
  useShortcut('lang.switch', toggleLanguage);
  return <ShortcutListDialog open={helpOpen} onOpenChange={setHelpOpen} />;
}